// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  owner: __t.identity(),
  round: __t.u32(),
  attempt: __t.u32(),
  seed: __t.u32(),
  ghostSeed: __t.u32().name("ghost_seed"),
  winner: __t.string(),
  outcomeJson: __t.string().name("outcome_json"),
  setupAJson: __t.string().name("setup_a_json"),
  setupBJson: __t.string().name("setup_b_json"),
  createdAt: __t.timestamp().name("created_at"),
});
